/* Evergleam festive effects: snow canvas, Santa flyover, Grump peek, snowman easter egg.
   Everything pauses when the tab is hidden and stays off under reduced motion. */
(function () {
  const EG = window.EG;

  /* ---------- Snow ---------- */
  function initSnow() {
    const canvas = document.querySelector('[data-snow]');
    if (!canvas) return;
    const toggle = document.querySelector('[data-snow-toggle]');
    const ctx = canvas.getContext('2d');
    const scopeHero = canvas.dataset.scope === 'hero';
    const KEY = 'eg:snow';
    let W = 0, H = 0, dpr = 1, flakes = [], raf = 0, last = 0, wind = 0, scrollV = 0, lastY = scrollY, running = false;
    let zones = [];
    const wanted = () => EG.store.get('localStorage', KEY, 'on') === 'on';
    const sprite = (r, a) => {
      const c = document.createElement('canvas'); const s = Math.ceil(r * 4 * dpr); c.width = c.height = s;
      const g = c.getContext('2d'); const gr = g.createRadialGradient(s / 2, s / 2, 0, s / 2, s / 2, s / 2);
      gr.addColorStop(0, `rgba(255,250,240,${a})`); gr.addColorStop(.5, `rgba(255,250,240,${a * .7})`); gr.addColorStop(1, 'rgba(255,250,240,0)');
      g.fillStyle = gr; g.fillRect(0, 0, s, s); return c;
    };
    const LAYERS = [{ r: 1.1, v: .45, a: .45 }, { r: 2, v: .8, a: .7 }, { r: 3.3, v: 1.3, a: .9 }];
    let sprites = [];
    const spawn = (any) => ({ x: Math.random() * W, y: any ? Math.random() * H : -10, L: Math.random() < .5 ? 0 : Math.random() < .7 ? 1 : 2, p: Math.random() * 6.3, s: .3 + Math.random() * .7 });
    function resize() {
      dpr = Math.min(devicePixelRatio || 1, 2); W = innerWidth; H = innerHeight;
      canvas.width = W * dpr; canvas.height = H * dpr; canvas.style.width = W + 'px'; canvas.style.height = H + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      sprites = LAYERS.map((l) => sprite(l.r, l.a));
      const n = Math.min(180, Math.floor((W * H) / (W < 750 ? 9000 : 6500)));
      while (flakes.length < n) flakes.push(spawn(true));
      flakes.length = n;
    }
    // Only paint snow over dark "snowy" sections when scope = hero
    function visibleZones() {
      if (!scopeHero) return [[0, H]];
      return [...document.querySelectorAll('[data-snowzone]')].map((z) => z.getBoundingClientRect()).filter((r) => r.bottom > 0 && r.top < H).map((r) => [Math.max(0, r.top), Math.min(H, r.bottom)]);
    }
    function tick(t) {
      raf = requestAnimationFrame(tick);
      if (t - last < 28) return;
      const dt = Math.min((t - last) / 16.7, 3); last = t;
      scrollV *= .9; wind += (Math.max(-3, Math.min(3, scrollV * .03)) - wind) * .05;
      ctx.clearRect(0, 0, W, H);
      zones = visibleZones();
      if (!zones.length) return;
      for (const f of flakes) {
        const l = LAYERS[f.L];
        f.p += .012 * dt; f.y += l.v * dt; f.x += (Math.sin(f.p) * f.s + wind * l.v) * dt;
        if (f.y > H + 10) Object.assign(f, spawn(false));
        if (f.x > W + 10) f.x = -10; else if (f.x < -10) f.x = W + 10;
        if (zones.some(([a, b]) => f.y >= a && f.y <= b)) ctx.drawImage(sprites[f.L], f.x, f.y, l.r * 4, l.r * 4);
      }
    }
    const start = () => { if (running || !EG.motion || !wanted()) return; running = true; canvas.hidden = false; last = performance.now(); raf = requestAnimationFrame(tick); };
    const stop = (clear) => { running = false; cancelAnimationFrame(raf); if (clear) { ctx.clearRect(0, 0, W, H); canvas.hidden = true; } };
    const sync = () => { if (!toggle) return; toggle.hidden = !EG.motion; toggle.setAttribute('aria-pressed', String(wanted() && EG.motion)); };
    addEventListener('scroll', () => { scrollV += scrollY - lastY; lastY = scrollY; }, { passive: true });
    addEventListener('resize', EG.debounce(resize, 200));
    document.addEventListener('visibilitychange', () => (document.hidden ? stop(false) : start()));
    EG.on('motion', () => { EG.motion ? start() : stop(true); sync(); });
    toggle?.addEventListener('click', () => {
      const on = !running; EG.store.set('localStorage', KEY, on ? 'on' : 'off'); on ? start() : stop(true); sync();
    });
    resize(); sync(); EG.idle(start);
  }

  /* ---------- Santa flyover ---------- */
  function initSanta(el) {
    const lane = el.parentElement;
    const bubble = el.querySelector('.char-bubble--santa');
    const fly = () => {
      if (!EG.motion || document.hidden) { setTimeout(fly, 15000); return; }
      el.style.setProperty('--travel', lane.clientWidth + 320 + 'px');
      el.style.setProperty('--fly-dur', Math.max(8, lane.clientWidth / 150) + 's');
      el.classList.remove('is-flying'); void el.offsetWidth; el.classList.add('is-flying');
    };
    el.addEventListener('animationend', (e) => {
      if (e.animationName !== 'santa-fly') return;
      el.classList.remove('is-flying'); if (bubble) bubble.hidden = true;
      setTimeout(fly, 22000);
    });
    el.addEventListener('click', () => { if (bubble) { bubble.hidden = false; setTimeout(() => { bubble.hidden = true; }, 1800); } });
    if (EG.motion) EG.near(lane, () => setTimeout(fly, 1800), '0px');
  }

  /* ---------- Grump peek: once per session after the shopper lingers ---------- */
  function initGrump(el) {
    if (!EG.motion || EG.store.get('sessionStorage', 'eg:grump')) return;
    let idle;
    const peek = () => { el.classList.add('is-peeking'); EG.store.set('sessionStorage', 'eg:grump', 1); off(); };
    const reset = () => { clearTimeout(idle); idle = setTimeout(peek, 3500); };
    const off = () => { clearTimeout(idle); removeEventListener('scroll', reset); removeEventListener('pointermove', reset); };
    EG.near(el.parentElement, () => { reset(); addEventListener('scroll', reset, { passive: true }); addEventListener('pointermove', reset, { passive: true }); }, '-25% 0px');
  }

  /* ---------- Snowman ---------- */
  function initSnowman(root) {
    const btn = root.querySelector('.snowman__btn');
    const box = root.querySelector('.snowman__code');
    btn.addEventListener('click', () => {
      const open = btn.classList.toggle('is-tipped');
      btn.setAttribute('aria-expanded', String(open));
      if (box) box.hidden = !open;
    });
    root.querySelector('[data-copy]')?.addEventListener('click', (e) => EG.copy(root.querySelector('[data-code]').textContent, e.currentTarget));
  }

  document.addEventListener('visibilitychange', () => document.documentElement.classList.toggle('fx-paused', document.hidden));
  const boot = () => {
    initSnow();
    document.querySelectorAll('[data-char="santa"]').forEach(initSanta);
    document.querySelectorAll('[data-grump-peek]').forEach(initGrump);
    document.querySelectorAll('[data-snowman]').forEach(initSnowman);
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
})();
